
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/oh-no",
      function () {
        return require("private-next-pages/oh-no.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/oh-no"])
      });
    }
  